import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import type { QueueName } from '@/types/support.types';

export type QueueTabKey = 'queue_respond' | 'queue_internal' | 'queue_client';

interface QueueTabsProps {
  activeQueue: QueueTabKey;
  onQueueChange: (queue: QueueTabKey) => void;
  counts: Record<QueueTabKey, number>;
}

const QUEUE_TAB_CONFIG: Array<{
  key: QueueTabKey;
  label: string;
  emoji: string;
  activeClass: string;
  badgeClass: string;
}> = [
  {
    key: 'queue_respond',
    label: 'Responder',
    emoji: '🔴',
    activeClass: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
    badgeClass: 'bg-destructive-foreground/20 text-destructive-foreground',
  },
  {
    key: 'queue_internal',
    label: 'Interno',
    emoji: '🟡',
    activeClass: 'bg-amber-500 text-white hover:bg-amber-500/90',
    badgeClass: 'bg-white/20 text-white',
  },
  {
    key: 'queue_client',
    label: 'Cliente',
    emoji: '🟢',
    activeClass: 'bg-emerald-500 text-white hover:bg-emerald-500/90',
    badgeClass: 'bg-white/20 text-white',
  },
];

export function QueueTabs({ activeQueue, onQueueChange, counts }: QueueTabsProps) {
  return (
    <div className="flex gap-1 p-1 bg-muted/50 rounded-full">
      {QUEUE_TAB_CONFIG.map((tab) => {
        const isActive = activeQueue === tab.key;
        const count = counts[tab.key] || 0;

        return (
          <Button
            key={tab.key}
            variant={isActive ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onQueueChange(tab.key)}
            className={cn(
              'flex-1 text-xs h-8 rounded-full gap-1.5',
              isActive ? tab.activeClass + ' shadow-sm' : 'hover:bg-muted'
            )}
          >
            <span className="hidden sm:inline">{tab.emoji}</span>
            {tab.label}
            {count > 0 && (
              <Badge
                variant="secondary"
                className={cn(
                  'text-xs h-5 min-w-5 px-1.5 rounded-full',
                  isActive && tab.badgeClass
                )}
              >
                {count}
              </Badge>
            )}
          </Button>
        );
      })}
    </div>
  );
}
